// extracted by mini-css-extract-plugin
module.exports = {"surveyLink":"c-l23","root":"_3FvIl","backgroundDark":"_3L-Xw","surveyText":"g8GtY","surveyDismissIcon":"_2G_vx","message":"_3OBD5","themeGreen":"_2C75c","globeIcon":"_2i-5A"};